var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrvtoNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 4.9585C18.6667 6.40516 17.4884 7.5835 16.0417 7.5835H11.9584C11.235 7.5835 10.5817 7.29183 10.1034 6.8135C9.62504 6.33516 9.33337 5.68183 9.33337 4.9585C9.33337 3.51183 10.5117 2.3335 11.9584 2.3335H16.0417C16.765 2.3335 17.4184 2.62516 17.8967 3.1035C18.375 3.58183 18.6667 4.23516 18.6667 4.9585Z",
    fill: "#3B9C4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9683 5.86866C21.7 5.64699 21.3966 5.47199 21.07 5.34366C20.7316 5.21532 20.3933 5.48366 20.3233 5.83366C19.9266 7.82866 18.165 9.33366 16.0416 9.33366H11.9583C10.7916 9.33366 9.69496 8.87866 8.86663 8.05032C8.25996 7.44366 7.83996 6.67366 7.67663 5.84532C7.60663 5.49532 7.25663 5.21532 6.91829 5.35532C5.56496 5.90366 4.66663 7.14032 4.66663 9.62532V21.0003C4.66663 24.5003 6.75496 25.667 9.33329 25.667H18.6666C21.245 25.667 23.3333 24.5003 23.3333 21.0003V9.62532C23.3333 7.72366 22.8083 6.55699 21.9683 5.86866ZM9.33329 14.292H14C14.4783 14.292 14.875 14.6887 14.875 15.167C14.875 15.6453 14.4783 16.042 14 16.042H9.33329C8.85496 16.042 8.45829 15.6453 8.45829 15.167C8.45829 14.6887 8.85496 14.292 9.33329 14.292ZM18.6666 20.7087H9.33329C8.85496 20.7087 8.45829 20.312 8.45829 19.8337C8.45829 19.3553 8.85496 18.9587 9.33329 18.9587H18.6666C19.145 18.9587 19.5416 19.3553 19.5416 19.8337C19.5416 20.312 19.145 20.7087 18.6666 20.7087Z",
    fill: "#3B9C4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrvtoNote);
export default __webpack_public_path__ + "static/media/trvto_note.3b2378cd2b1fbcda4f8fa58c259a67a9.svg";
export { ForwardRef as ReactComponent };